import { render, staticRenderFns } from "./newBusinessOpenProcessRecord.vue?vue&type=template&id=ef8eadb6&scoped=true"
import script from "./newBusinessOpenProcessRecord.vue?vue&type=script&lang=ts"
export * from "./newBusinessOpenProcessRecord.vue?vue&type=script&lang=ts"
import style0 from "./newBusinessOpenProcessRecord.vue?vue&type=style&index=0&id=ef8eadb6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8eadb6",
  null
  
)

export default component.exports